//需要派发的数据
import { $post } from "utils/create-http";
export const ACTION_SET_BOOKS = "SET_BOOKS";
export const ACTION_DELETE_BOOK = "DELETE_BOOK";
export const ACTION_SET_EDITOR_BOOK_ID = "SET_EDITOR_BOOK_ID";
export const ACTION_SET_USER_INFO = "SET_USER_INFO";

// 文件上传相关actions
export const ACTION_SET_UPLOAD_FILE = "SET_UPLOAD_FILE";
export const ACTION_CLEAR_UPLOAD_FILE = "CLEAR_UPLOAD_FILE";

export const setUserInfo = (info) => {
  return {
    type: ACTION_SET_USER_INFO,
    payload: info,
  };
};
export const getUserInfo = (user_id) => {
  return (dispatch) => {
    return $post("/towords_book/v1/user/get_user_info", { user_id }).then(
      (res) => {
        if (res.code == 200) {
          dispatch(setUserInfo(res?.result));
        }
      }
    );
  };
};
export const setEditorBookId = (book_id) => {
  return {
    type: ACTION_SET_EDITOR_BOOK_ID,
    payload: book_id,
  };
};

export function setBooks(books) {
  return {
    type: ACTION_SET_BOOKS,
    payload: books,
  };
}

export function deleteBook(idx) {
  return {
    type: ACTION_DELETE_BOOK,
    payload: idx,
  };
}

// 文件上传相关action creators
export const setUploadFile = (fileData) => {
  return {
    type: ACTION_SET_UPLOAD_FILE,
    payload: fileData,
  };
};

export const clearUploadFile = () => {
  return {
    type: ACTION_CLEAR_UPLOAD_FILE,
  };
};
